// 产品类型
export const PRODUCT_CODE = {
  categoryCode_FL00000001: 'FL00000001', //  充值服务大类1
  categoryCode_FL00000002: 'FL00000002', //  话费充值2
  categoryCode_FL00000003: 'FL00000003', //  加油卡充值2
  categoryCode_FL10000001: 'FL10000001', //  道路救援大类1
  categoryCode_FL10000002: 'FL10000002', //  拖车2
  categoryCode_FL10000003: 'FL10000003', //  地库拖车2
  categoryCode_FL10000004: 'FL10000004', //  轮胎打气2
  categoryCode_FL10000005: 'FL10000005', //  更换轮胎2
  categoryCode_FL10000006: 'FL10000006', //  搭电2
  categoryCode_FL10000007: 'FL10000007', //  取送钥匙2
  categoryCode_FL10000008: 'FL10000008', //  送水2
  categoryCode_FL10000009: 'FL10000009', //  送油2
  categoryCode_FL10000010: 'FL10000010', //  送防冻液2
  categoryCode_FL10000011: 'FL10000011', //  现场维修2
  categoryCode_FL10000013: 'FL10000013', //  新能源接电2
  categoryCode_FL10000014: 'FL10000014', //  拖车责任险2
  categoryCode_FL10000015: 'FL10000015', //  代客充电2
  categoryCode_FL10000016: 'FL10000016', //  APP红包2
  categoryCode_FL50000000: 'FL50000000', //  风险查勘大类1
  categoryCode_FL50000003: 'FL50000003', // 装修贷2
  categoryCode_FL20000001: 'FL20000001', // 汽车养护大类1
  categoryCode_FL20000002: 'FL20000002', // 一键加油2
  categoryCode_FL20000003: 'FL20000003', // 汽车普洗2
  categoryCode_FL20000004: 'FL20000004', // 玻璃维修2
  categoryCode_FL20000005: 'FL20000005', // 划痕补漆2
  categoryCode_FL20000006: 'FL20000006', // 打蜡磨泥2
  categoryCode_FL20000007: 'FL20000007', // 打蜡抛光2
  categoryCode_FL20000008: 'FL20000008', // 空调除菌2
  categoryCode_FL20000009: 'FL20000009', // 臭氧消毒2
  categoryCode_FL20000010: 'FL20000010', // 全合成4升2
  categoryCode_FL20000011: 'FL20000011', // 半合成4升2
  categoryCode_FL20000012: 'FL20000012', // 免费车辆安全检测2
  categoryCode_FL20000013: 'FL20000013', // 大客户标准洗车2
  categoryCode_FL20000014: 'FL20000014', // 全车安全检测2
  categoryCode_FL20000015: 'FL20000015', // 贴片式补胎2
  categoryCode_FL20000016: 'FL20000016', // 车辆精洗2
  categoryCode_FL20000017: 'FL20000017', // 集团客户全车打蜡2
  categoryCode_FL20000018: 'FL20000018', // 集团客户爱车养护礼包四件套2
  categoryCode_FL20000019: 'FL20000019', // 集团客户杀菌消毒2
  categoryCode_FL20000020: 'FL20000020', // 集团客户喷漆2
  categoryCode_FL20000021: 'FL20000021', // 更换机油及机油滤清器2
  categoryCode_FL20000022: 'FL20000022', // 更换内置空调滤清器2
  categoryCode_FL20000023: 'FL20000023', // 免费添加玻璃水2
  categoryCode_FL40000001: 'FL40000001', // 安全检测大类1
  categoryCode_FL40000002: 'FL40000002', // 安全检测2
  categoryCode_FL40000003: 'FL40000003', // 发动机检测2
  categoryCode_FL40000004: 'FL40000004', // 变速器检测+底盘检测2
  categoryCode_FL40000005: 'FL40000005', // 转向系统检测2
  categoryCode_FL40000006: 'FL40000006', // 轮胎检测2
  categoryCode_FL40000007: 'FL40000007', // 汽车玻璃检测2
  categoryCode_FL40000008: 'FL40000008', // 汽车电子系统检测2
  categoryCode_FL40000009: 'FL40000009', // 车内环境检测2
  categoryCode_FL400000010: 'FL40000010', // 蓄电池检测2
  categoryCode_FL400000011: 'FL40000011', // 车辆综合安全检测2
  categoryCode_FL400000012: 'FL40000012', // 四轮+动平衡检测2
  categoryCode_FL400000013: 'FL40000013', // 动平衡检测2
  categoryCode_FL400000014: 'FL40000014', // 四轮定位检测2
  categoryCode_FL400000015: 'FL40000015', // 新能源车电池检测
  categoryCode_FL400000022: 'FL40000022', // 新能源电池事故检测
  categoryCode_FL400000023: 'FL40000023', // 新能源电池风险减量检测
  categoryCode_FL400000016: 'FL40000016', // 车辆综合安全检测A款
  categoryCode_FL400000017: 'FL40000017', // 车辆综合安全检测B款
  categoryCode_FL400000018: 'FL40000018', // 车辆综合安全检测C款
  categoryCode_FL60000001: 'FL60000001', // 车辆年检大类1
  categoryCode_FL60000002: 'FL60000002', // 免上线年检2
  categoryCode_FL60000003: 'FL60000003', // 上线年检（自驾）2
  categoryCode_FL60000004: 'FL60000004', // 上线年检（取送车）2
  categoryCode_FL70000001: 'FL70000001', // 车辆代驾大类1
  categoryCode_FL70000002: 'FL70000002', // 车辆代驾2
  categoryCode_FL70000003: 'FL70000003', // 车辆代驾（取送车）2
  categoryCode_FL30000001: 'FL30000001', // 虚拟物品大类  1
  categoryCode_FL30000002: 'FL30000002', // 礼品卡2
  categoryCode_FL30000003: 'FL30000003', // 视听卡2
  categoryCode_FL80000001: 'FL80000001', // 查询服务1
  categoryCode_FL80000002: 'FL80000002', // 违章2
  categoryCode_FL80000003: 'FL80000003', // 罚单2
  categoryCode_FL90000001: 'FL90000001', // 事故救援1
  categoryCode_FL90000002: 'FL90000002', // 事故拖车2
  categoryCode_FL90000003: 'FL90000003', // 事故困境2
  categoryCode_FL90000004: 'FL90000004', // 事故救援2
  categoryCode_FLA0000001: 'FLA0000001', // 困境救援1
  categoryCode_FLA0000002: 'FLA0000002', // 困境救援2
  categoryCode_FLH0000001: 'FLH0000001', // 健康险服务大类1
  categoryCode_FLH0000002: 'FLH0000002', // 绿色通道2
  categoryCode_FLH0000003: 'FLH0000003', // 陪诊服务2
  categoryCode_FLH0000004: 'FLH0000004', // 线上服务2
  categoryCode_FLH0000005: 'FLH0000005', // 眼科服务2
  categoryCode_FLH0000006: 'FLH0000006', // 齿科服务2
  categoryCode_FLH0000007: 'FLH0000007', // 上门服务2
  categoryCode_FLH0000008: 'FLH0000008', // 家政服务2
  categoryCode_FLH0000010: 'FLH0000010' // 健康体检2
};
/**
 * 取送车:FL70000003
事故救援:FL90000001
事故拖车:FL90000002
事故困境:FL90000003
困境救援:FLA0000001
困境救援:FLA0000002
汽车普洗:FL20000003
 */

/** 产品大类*/
export const TOP_CATEGORY_CODES = {
  /** 充值服务*/
  rechargeType: 'FL00000001',
  /** 道路救援*/
  roadRescueType: 'FL10000001',
  /** 汽车养护 */
  vehicleCuringType: 'FL20000001',
  /** 虚拟物品*/
  virtualGoodsType: 'FL30000001',
  /** 安全检测*/
  safetyDetectionType: 'FL40000001',
  /** 风险查勘*/
  riskSurveyType: 'FL50000000',
  /** 车辆年检*/
  vehicleInspectionType: 'FL60000001',
  /** 车辆代驾*/
  vehicleSubstituteDrivingType: 'FL70000001',
  /** 查询服务*/
  queryServiceType: 'FL80000001',
  /** 事故救援 */
  accidentRescueType: 'FL90000001',
  /** 困境救援 */
  distressRescueType: 'FLA0000001',
  /** 健康险服务 */
  healthInsuranceType: 'FLH0000001'
};

// 产品小类归属
export const PRODUCT_CODE_TYPE = {
  // 充值服务
  rechargeType: [
    PRODUCT_CODE.categoryCode_FL00000002,
    PRODUCT_CODE.categoryCode_FL00000003
  ],
  // 道路救援
  roadRescueType: [
    PRODUCT_CODE.categoryCode_FL10000002,
    PRODUCT_CODE.categoryCode_FL10000003,
    PRODUCT_CODE.categoryCode_FL10000004,
    PRODUCT_CODE.categoryCode_FL10000005,
    PRODUCT_CODE.categoryCode_FL10000006,
    PRODUCT_CODE.categoryCode_FL10000007,
    PRODUCT_CODE.categoryCode_FL10000008,
    PRODUCT_CODE.categoryCode_FL10000009,
    PRODUCT_CODE.categoryCode_FL10000010,
    PRODUCT_CODE.categoryCode_FL10000011,
    PRODUCT_CODE.categoryCode_FL10000013,
    PRODUCT_CODE.categoryCode_FL10000015
  ],
  // 车辆年检
  vehicleInspectionType: [
    PRODUCT_CODE.categoryCode_FL60000002,
    PRODUCT_CODE.categoryCode_FL60000003,
    PRODUCT_CODE.categoryCode_FL60000004
  ],
  // 风险查勘
  riskSurveyType: [PRODUCT_CODE.categoryCode_FL50000003],
  // 汽车养护
  vehicleCuringType: [
    PRODUCT_CODE.categoryCode_FL20000002,
    PRODUCT_CODE.categoryCode_FL20000003
  ],
  // 到店业务类型
  instoreType: [
    // 2.25.0 新加同到店洗车
    PRODUCT_CODE.categoryCode_FL20000004,
    PRODUCT_CODE.categoryCode_FL20000005,
    PRODUCT_CODE.categoryCode_FL20000006,
    PRODUCT_CODE.categoryCode_FL20000007,
    PRODUCT_CODE.categoryCode_FL20000008,
    PRODUCT_CODE.categoryCode_FL20000009,
    PRODUCT_CODE.categoryCode_FL20000010,
    PRODUCT_CODE.categoryCode_FL20000011,
    PRODUCT_CODE.categoryCode_FL20000022,
    PRODUCT_CODE.categoryCode_FL20000023,
    // 原到店
    PRODUCT_CODE.categoryCode_FL20000012,
    PRODUCT_CODE.categoryCode_FL20000013,
    PRODUCT_CODE.categoryCode_FL20000014,
    PRODUCT_CODE.categoryCode_FL20000015,
    PRODUCT_CODE.categoryCode_FL20000016,
    PRODUCT_CODE.categoryCode_FL20000017,
    PRODUCT_CODE.categoryCode_FL20000018,
    PRODUCT_CODE.categoryCode_FL20000019,
    PRODUCT_CODE.categoryCode_FL20000020,
    PRODUCT_CODE.categoryCode_FL20000021
  ],
  // 安全检测
  safetyDetectionType: [
    PRODUCT_CODE.categoryCode_FL40000002,
    PRODUCT_CODE.categoryCode_FL400000012,
    PRODUCT_CODE.categoryCode_FL400000013,
    PRODUCT_CODE.categoryCode_FL400000014,
    PRODUCT_CODE.categoryCode_FL400000015
  ],
  // 车辆代驾
  vehicleSubstituteDrivingType: [
    PRODUCT_CODE.categoryCode_FL70000002,
    PRODUCT_CODE.categoryCode_FL70000003
  ],
  // 虚拟物品
  virtualGoodsType: [
    PRODUCT_CODE.categoryCode_FL30000002,
    PRODUCT_CODE.categoryCode_FL30000003
  ],
  // 查询服务
  queryServiceType: [
    PRODUCT_CODE.categoryCode_FL80000002,
    PRODUCT_CODE.categoryCode_FL80000003
  ],
  // 事故救援
  accidentRescueType: [
    PRODUCT_CODE.categoryCode_FL90000002,
    PRODUCT_CODE.categoryCode_FL90000003,
    PRODUCT_CODE.categoryCode_FL90000004
  ],
  // 困境救援
  distressRescueType: [PRODUCT_CODE.categoryCode_FLA0000002],
  // 钣喷门店类型（安全检测）
  sprayingStoreType: [
    PRODUCT_CODE.categoryCode_FL40000002,
    PRODUCT_CODE.categoryCode_FL40000003,
    PRODUCT_CODE.categoryCode_FL40000004,
    PRODUCT_CODE.categoryCode_FL40000005,
    PRODUCT_CODE.categoryCode_FL40000006,
    PRODUCT_CODE.categoryCode_FL40000007,
    PRODUCT_CODE.categoryCode_FL40000008,
    PRODUCT_CODE.categoryCode_FL40000009,
    PRODUCT_CODE.categoryCode_FL400000010,
    PRODUCT_CODE.categoryCode_FL400000011,
    PRODUCT_CODE.categoryCode_FL400000016,
    PRODUCT_CODE.categoryCode_FL400000017,
    PRODUCT_CODE.categoryCode_FL400000018
  ],
  // 车辆综合安全检测
  safetyDetectionTypeOther: [
    PRODUCT_CODE.categoryCode_FL400000016,
    PRODUCT_CODE.categoryCode_FL400000017,
    PRODUCT_CODE.categoryCode_FL400000018,
    PRODUCT_CODE.categoryCode_FL400000022,
    PRODUCT_CODE.categoryCode_FL400000023
  ],
  // 车生活
  carLifeType: [
    PRODUCT_CODE.categoryCode_FL00000002,
    PRODUCT_CODE.categoryCode_FL00000003,
    PRODUCT_CODE.categoryCode_FL20000002,
    PRODUCT_CODE.categoryCode_FL80000002,
    PRODUCT_CODE.categoryCode_FL80000003,
    PRODUCT_CODE.categoryCode_FL30000002,
    PRODUCT_CODE.categoryCode_FL30000003
  ],
  // 新能源新增类型
  newEnergyType: [
    PRODUCT_CODE.categoryCode_FL400000022,
    PRODUCT_CODE.categoryCode_FL400000023
  ],
  // 健康险服务
  healthInsuranceType: [
    PRODUCT_CODE.categoryCode_FLH0000002,
    PRODUCT_CODE.categoryCode_FLH0000003,
    PRODUCT_CODE.categoryCode_FLH0000004,
    PRODUCT_CODE.categoryCode_FLH0000005,
    PRODUCT_CODE.categoryCode_FLH0000006,
    PRODUCT_CODE.categoryCode_FLH0000007,
    PRODUCT_CODE.categoryCode_FLH0000008,
    PRODUCT_CODE.categoryCode_FLH0000010
  ],
  // 健康险服务-优加1
  healthInsuranceType1: [
    PRODUCT_CODE.categoryCode_FLH0000002,
    PRODUCT_CODE.categoryCode_FLH0000003,
    PRODUCT_CODE.categoryCode_FLH0000004
  ],
  // 健康险服务-标准接口2
  healthInsuranceType2: [
    PRODUCT_CODE.categoryCode_FLH0000005,
    PRODUCT_CODE.categoryCode_FLH0000006,
    PRODUCT_CODE.categoryCode_FLH0000008,
    PRODUCT_CODE.categoryCode_FLH0000010
  ],
  // 健康险服务-乐荐3
  healthInsuranceType3: [
    PRODUCT_CODE.categoryCode_FLH0000007
  ]
};
